import $ from 'jquery';
window.$ = window.jQuery = $;

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';

import RevealEffects from './js/reveal-effects'

import './scss/app.scss';

$(document).ready(() => {
  $('.main-nav__collapse').on('show.bs.collapse', function () {
    $(this).addClass("show");
  }).on('hide.bs.collapse', function () {
    $(this).removeClass("show");
  })

  RevealEffects();

});
